import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, inputCls } from "@/pages/Login";

export default function InviteAccept() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [bad, setBad] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { setUser } = useAuth();
  const nav = useNavigate();
  useEffect(() => { api.get(`/auth/invite/${token}`).then((r) => setInfo(r.data)).catch(() => setBad(true)); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/invite/accept", { token, email, password });
      setUser(data);
      nav(`/nadzorna-plosca/${data.wedding_id}`);
    } catch (er) { toast.error(errMsg(er)); }
  };

  if (bad) return <AuthShell title="Povabilo ni veljavno" subtitle="Povezava je potekla ali je bila že uporabljena." />;
  return (
    <AuthShell title="Povabilo k urejanju" subtitle={info ? `Povabljeni ste k skupnemu urejanju poroke ${info.wedding_title}.` : "Nalaganje …"}>
      <form onSubmit={submit} className="space-y-4" data-testid="invite-form">
        <input className={inputCls} type="email" placeholder="E-poštni naslov" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="invite-email-input" />
        <input className={inputCls} type="password" placeholder="Geslo (vsaj 8 znakov)" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="invite-password-input" />
        <p className="text-xs text-[#6C6560]">Če račun s tem naslovom že obstaja, vnesite obstoječe geslo.</p>
        <button className="btn-dark w-full h-12" data-testid="invite-submit-button">Sprejmi povabilo</button>
      </form>
    </AuthShell>
  );
}
